import { Card, Text } from '@radix-ui/themes';
import clsx from 'clsx';
import { HubertBadge } from 'components/HubertUI/HubertBadge';
import type { ComponentProps } from 'react';
import type { ClosedMessageDocument } from '@hubertai/screening-question-types';
import type { TChatCollection } from 'types/scores.types';
import AnswerEvaluation from '../AnswerEvaluation';

interface CandidateMessageProps extends ComponentProps<'div'> {
  collection: TChatCollection;
  answer: ClosedMessageDocument;
}

const CandidateDatePickerAnswer = ({ collection, answer, ...props }: CandidateMessageProps) => {
  return (
    <div {...props} className={clsx('flex flex-col justify-end gap-2')}>
      <div {...props} className={clsx('flex flex-row justify-end gap-2')}>
        <Card className={clsx('max-w-[80%]', 'flex flex-col justify-between', 'p-2')}>
          <Text as="div" size="2" color="gray">
            {/* Echoed from the candidate payload — must never be rendered as HTML (XSS) */}
            <div>{answer.text ?? ''}</div>
          </Text>
        </Card>

        <AnswerEvaluation evaluation={collection.evaluation ? collection.evaluation.evaluation : undefined} />
      </div>
      <div className={clsx('flex flex-row justify-end gap-4')}>
        {answer.reusage && answer.reusage.is_reused ? (
          <HubertBadge variant={'info'}>
            {answer.reusage?.is_edited ? 'Reused answer: edited' : 'Reused answer: Not edited'}
          </HubertBadge>
        ) : null}
      </div>
    </div>
  );
};

export default CandidateDatePickerAnswer;
